import { BucketPairReportStatus } from "helpers/types";

/**
 * The warning line for the bucket pairs a run reported as failed, one
 * "B<bucket> <symbol> <option type>: <message>" entry per pair.
 */
export const pairFailuresMessage = (
  failures: BucketPairReportStatus[],
): string =>
  failures
    .map(
      (failure) =>
        `B${failure.bucket}${failure.symbol ? ` ${failure.symbol}` : ""}${
          failure.option_type ? ` ${failure.option_type}` : ""
        }: ${failure.message}`,
    )
    .join(" · ");
